import React, { useEffect } from "react";
import { Container, Row, Col } from "react-bootstrap";
import Pagination from "react-bootstrap/Pagination";
import { useSearchParams } from "react-router-dom";
import Particle from "../Particle";
import BlogCard from "./BlogCard";
import AnimatedSection, { StaggerContainer, StaggerItem } from "../AnimatedSection";
import { blogs } from "../../data/blogs";

const BLOGS_PER_PAGE = 6;

function Blogs() {
  const [searchParams, setSearchParams] = useSearchParams();
  const totalPages = Math.ceil(blogs.length / BLOGS_PER_PAGE);
  const requestedPage = Number(searchParams.get("page")) || 1;
  const currentPage = Math.min(Math.max(requestedPage, 1), totalPages);

  const startIndex = (currentPage - 1) * BLOGS_PER_PAGE;
  const paginatedBlogs = blogs.slice(startIndex, startIndex + BLOGS_PER_PAGE);

  useEffect(() => {
    if (requestedPage !== currentPage) {
      setSearchParams({ page: currentPage.toString() }, { replace: true });
    }
  }, [requestedPage, currentPage, setSearchParams]);

  function goToPage(page) {
    setSearchParams({ page: page.toString() });
    window.scrollTo({ top: 0, behavior: "smooth" });
  }

  return (
    <Container fluid className="project-section">
      <Particle />
      <Container>
        <AnimatedSection>
          <h1 className="project-heading">
            Tech <span className="purple">Blogs</span>
          </h1>
          <p className="section-subtitle">
            Articles on React Native, React, Next.js, Android, iOS, and lessons
            from building production mobile and web applications.
          </p>
          <p className="blog-results-count">
            Showing {startIndex + 1}–{Math.min(startIndex + BLOGS_PER_PAGE, blogs.length)} of {blogs.length} articles
          </p>
        </AnimatedSection>

        <StaggerContainer key={currentPage}>
          <Row style={{ justifyContent: "center", paddingBottom: "20px" }}>
            {paginatedBlogs.map((blog) => (
              <Col md={4} className="blog-card" key={blog.slug}>
                <StaggerItem>
                  <BlogCard blog={blog} />
                </StaggerItem>
              </Col>
            ))}
          </Row>
        </StaggerContainer>

        {totalPages > 1 && (
          <div className="blog-pagination-wrap">
            <Pagination className="blog-pagination">
              <Pagination.Prev
                disabled={currentPage === 1}
                onClick={() => goToPage(currentPage - 1)}
              />
              {Array.from({ length: totalPages }, (_, i) => i + 1).map((page) => (
                <Pagination.Item
                  key={page}
                  active={page === currentPage}
                  onClick={() => goToPage(page)}
                >
                  {page}
                </Pagination.Item>
              ))}
              <Pagination.Next
                disabled={currentPage === totalPages}
                onClick={() => goToPage(currentPage + 1)}
              />
            </Pagination>
          </div>
        )}
      </Container>
    </Container>
  );
}

export default Blogs;
